import { Papel, StatusPedido, TipoEntrega } from '../dominio.js';
const TODOS_OPERACIONAIS = [Papel.ADMIN, Papel.GERENTE, Papel.ATENDENTE];
const CANCELAR_PADRAO = {
    para: StatusPedido.CANCELADO,
    papeis: TODOS_OPERACIONAIS,
    exigeMotivo: true,
};
export const TRANSICOES = {
    [StatusPedido.RECEBIDO]: [
        { para: StatusPedido.ACEITO, papeis: TODOS_OPERACIONAIS },
        CANCELAR_PADRAO,
    ],
    [StatusPedido.ACEITO]: [
        { para: StatusPedido.EM_PREPARO, papeis: [...TODOS_OPERACIONAIS, Papel.COZINHA] },
        CANCELAR_PADRAO,
    ],
    [StatusPedido.EM_PREPARO]: [
        { para: StatusPedido.PRONTO, papeis: [...TODOS_OPERACIONAIS, Papel.COZINHA] },
        CANCELAR_PADRAO,
    ],
    [StatusPedido.PRONTO]: [
        {
            para: StatusPedido.SAIU_PARA_ENTREGA,
            papeis: [...TODOS_OPERACIONAIS, Papel.ENTREGADOR],
            tipos: [TipoEntrega.ENTREGA],
        },
        {
            para: StatusPedido.ENTREGUE,
            papeis: [...TODOS_OPERACIONAIS, Papel.ENTREGADOR],
            tipos: [TipoEntrega.RETIRADA, TipoEntrega.BALCAO],
        },
        CANCELAR_PADRAO,
    ],
    [StatusPedido.SAIU_PARA_ENTREGA]: [
        { para: StatusPedido.ENTREGUE, papeis: [...TODOS_OPERACIONAIS, Papel.ENTREGADOR] },
        // Cancelar depois de sair exige mais poder: o produto já saiu da loja.
        { para: StatusPedido.CANCELADO, papeis: [Papel.ADMIN, Papel.GERENTE], exigeMotivo: true },
    ],
    [StatusPedido.ENTREGUE]: [
        { para: StatusPedido.CANCELADO, papeis: [Papel.ADMIN, Papel.GERENTE], exigeMotivo: true },
    ],
    [StatusPedido.CANCELADO]: [],
};
export const STATUS_TERMINAIS = [StatusPedido.CANCELADO];
export function podeTransicionar(args) {
    const { de, para, papel, tipo } = args;
    const candidatas = TRANSICOES[de].filter((t) => t.para === para);
    if (candidatas.length === 0) {
        return {
            ok: false,
            motivo: 'TRANSICAO_INVALIDA',
            mensagem: `Pedido em ${de} não pode ir para ${para}.`,
        };
    }
    const porTipo = candidatas.filter((t) => !t.tipos || t.tipos.includes(tipo));
    if (porTipo.length === 0) {
        return {
            ok: false,
            motivo: 'TIPO_INCOMPATIVEL',
            mensagem: `${para} não se aplica a pedido do tipo ${tipo}.`,
        };
    }
    const permitida = porTipo.find((t) => t.papeis.includes(papel));
    if (!permitida) {
        return {
            ok: false,
            motivo: 'PAPEL_SEM_PERMISSAO',
            mensagem: `O papel ${papel} não pode mover o pedido para ${para}.`,
        };
    }
    if (permitida.exigeMotivo && !args.temMotivo) {
        return {
            ok: false,
            motivo: 'MOTIVO_OBRIGATORIO',
            mensagem: 'Cancelamento exige motivo.',
        };
    }
    return { ok: true, exigeMotivo: permitida.exigeMotivo ?? false };
}
/** Próximos status possíveis — alimenta os botões do Kanban. */
export function proximosStatus(de, papel, tipo) {
    return TRANSICOES[de]
        .filter((t) => (!t.tipos || t.tipos.includes(tipo)) && t.papeis.includes(papel))
        .map((t) => t.para);
}
export function statusEhTerminal(status) {
    return status === StatusPedido.ENTREGUE || STATUS_TERMINAIS.includes(status);
}
//# sourceMappingURL=statusMachine.js.map